import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { SVGPDP } from '../../../../Svg/ProductPage';
import {
  formatIndianNumber,
  getPriceParams,
} from '../../../../Utils/productPageUtils';
import { SkeletonBox } from '../../../Product/Skeleton/styled';
import {
  ProdRatingStar,
  RatingCount,
  RatingDiv,
  ReadReviewsStyle,
  StarandReview,
  TotalRating,
} from './styled';
import { fireEvent } from '../../../../Utils/fireEvent';

export default function ProductRating(props) {
  let { width, height, productData, showNewPriceSection, isFertilityProduct } =
    props;
  const avgRating = productData?.avg_rating;
  const router = useRouter();
  const [lowOpacity, setLowOpacity] = useState(false);
  const clickHandler = (parent) => {
    setLowOpacity(true);
    router.push(`/reviews/${productData?.id || productData?._id}`);
    setTimeout(() => {
      setLowOpacity(false);
    }, [200]);
    fireClickedAddReview('clicked_show_more_review', parent);
  };
  const fireClickedAddReview = (eventName, parent) => {
    const { pricingParam, conversionParam } = getPriceParams(productData);
    fireEvent({
      category: eventName,
      product_id: productData?.id,
      support_variable: 'Product Detail',
      term_id: productData?.offers?.[0]?.term_id,
      offer_id: productData?.offers?.[0]?.offer_id,
      screen_name: 'PDP',
      pricing_param: pricingParam,
      conversion_param: conversionParam,
      trust_tag: productData?.signal?.name || '',
      Sku_id: productData?.id,
      parent: parent,
    });
  };
  // const handleReviewCountClick = () => {
  //     setLowOpacity(true);
  //     const offSet = document.getElementById("Rating").offsetTop - 10;
  //     window.scrollTo({
  //         top: offSet,
  //         behavior: "smooth",
  //     });
  //     setTimeout(() => {
  //         setLowOpacity(false);
  //     }, [200]);
  // };
  if (showNewPriceSection === null)
    return <SkeletonBox height="28px" width="100%" />;

  return (
    <StarandReview>
      <div className="ratingContainer">
        <ProdRatingStar width={width} height={height}>
          {Array.from(new Array(5).keys())?.map((index) => {
            const svgId =
              avgRating >= index + 1
                ? 'new-filled-star'
                : avgRating - index <= 0
                  ? 'new-star-empty'
                  : null;
            return (
              <li key={`ratingstars${index}`}>
                {avgRating == 0 ? (
                  <SVGPDP id="new-star-empty" />
                ) : svgId ? (
                  <SVGPDP id={svgId} />
                ) : (
                  <img src={images.new_star_half_empty} alt="half_star" />
                )}
              </li>
            );
          })}
        </ProdRatingStar>

        {showNewPriceSection ? (
          <RatingDiv onClick={() => clickHandler('ratings_section_top')}>
            <TotalRating>{productData?.avg_rating}</TotalRating>
            <RatingCount size={'0.75em'}>
              (
              {formatIndianNumber(
                isFertilityProduct
                  ? productData?.rating_count * 22
                  : productData?.rating_count,
              )}{' '}
              Ratings)
            </RatingCount>
          </RatingDiv>
        ) : (
          <>
            <RatingDiv onClick={() => clickHandler('ratings_section_top')}>
              <TotalRating>{productData?.avg_rating}</TotalRating>
              <RatingCount>({productData?.rating_count})</RatingCount>
            </RatingDiv>
            <RatingCount
              seperator="1px solid hsl(0deg,0%,0%,10%)"
              onClick={() => clickHandler('reviews_section_top')}
            >
              {productData?.review_count} Reviews
            </RatingCount>
          </>
        )}
      </div>
      {showNewPriceSection ? (
        <ReadReviewsStyle
          onClick={() => clickHandler('reviews_section_top')}
          lowOpacity={lowOpacity}
        >
          {formatIndianNumber(productData?.review_count)} Reviews
        </ReadReviewsStyle>
      ) : (
        <>
          {/* <ShareProduct
                        setShowToast={setShowToast}
                        productData={productData}
                        showNewPriceSection={showNewPriceSection}
                    />
                    <SnackBar className={showToast ? "show" : ""}>
                        Copied to clipboard!
                    </SnackBar> */}
        </>
      )}
    </StarandReview>
  );
}
